<app-adminheader [profileDetails]="profileUpdate"></app-adminheader>
<div class="container admin-profile">
  <p class="breadcrums arrow" (click)="GoToDashboard()">
    <span class="material-icons">arrow_back_ios_new</span>
    Back to Dashboard
  </p>
  <mat-card class="card-container profile-component">
    <div class="row">
      <div class="col-md-4">
        <mat-card-content class="card-container-right">
          <div layout="column">
            <div [class.spinner]="profileLoading"></div>

            <img
              mat-card-sm-image
              src="{{ profileImage ? profileImage : '' }}"
            />
            <div class="update-profile" *ngIf="editGeneralInfo">
              <button
                mat-raised-button
                #fileInput
                type="file"
                [class.spinner]="loading"
                [disabled]="loading"
                (change)="onChange($event)"
              >
                <span>Update Profile Picture </span>
                <input #fileInput type="file" (change)="onChange($event)" />
              </button>
            </div>
            <div class="change-password" *ngIf="editGeneralInfo">
              <button
                [class.spinner]="loading"
                [disabled]="loading"
                type="button"
                mat-raised-button
                color="warn"
                (click)="updateProfile()"
              >
                Save
              </button>
            </div>
          </div>
        </mat-card-content>
      </div>
      <!-- General Account Details -->
      <div class="col-md-8 input-fileds-container">
        <mat-card-content class="card-container-left">
          <form [formGroup]="profileForm">
            <div layout="column">
              <div class="card-details-container">
                <div class="card-details-header">
                  <h3>General Account Details</h3>
                  <a (click)="onEditProfile()" *ngIf="edit1">Edit</a>
                </div>
                <div class="card-details">
                  <div class="card-details-left">
                    Name
                    <span *ngIf="editGeneralInfo" style="color: brown">*</span>
                  </div>
                  <div class="card-details-right" *ngIf="!editGeneralInfo">
                    {{ profileData?.name }}
                  </div>
                  <div class="card-details-right" *ngIf="editGeneralInfo">
                    <mat-form-field>
                      <input
                        matInput
                        formControlName="name"
                        style="text-transform: capitalize"
                        required
                      />
                      <mat-error
                        *ngIf="(ProfileFormControl['name'].touched) && ProfileFormControl['name'].errors?.['pattern']"
                      >
                        Please Enter Valid Name</mat-error
                      >
                      <mat-error
                        *ngIf="(ProfileFormControl['name'].touched) && ProfileFormControl['name'].errors?.['required']"
                      >
                        Name is Required</mat-error
                      >
                    </mat-form-field>
                  </div>
                </div>
                <div class="card-details">
                  <div class="card-details-left">Username</div>
                  <div class="card-details-right" *ngIf="!editGeneralInfo">
                    {{ profileData?.username }}
                  </div>
                  <div class="card-details-right" *ngIf="editGeneralInfo">
                    <mat-form-field>
                      <input matInput formControlName="username" readonly style="color: #9e9e9e !important;" />
                    </mat-form-field>
                  </div>
                </div>
                <div class="card-details">
                  <div class="card-details-left">Employee Id</div>
                  <div class="card-details-right" *ngIf="!editGeneralInfo">
                    {{ profileData?.employee_id }}
                  </div>
                  <div class="card-details-right" *ngIf="editGeneralInfo">
                    <mat-form-field>
                      <input matInput formControlName="employee_id" readonly style="color: #9e9e9e !important;" />
                    </mat-form-field>
                  </div>
                </div>
                <div class="card-details">
                  <div class="card-details-left">Contact</div>
                  <div class="card-details-right" *ngIf="!editGeneralInfo">
                    <!-- {{this.data.mobile}} -->
                    {{ profileData?.mobile }}
                    <span>
                      <img src="../../../assets/img/tick-verify.svg" />
                    </span>
                  </div>
                  <div class="card-details-right" *ngIf="editGeneralInfo">
                    <mat-form-field>
                      <input matInput formControlName="mobile" readonly style="color: #9e9e9e !important;" />
                    </mat-form-field>
                  </div>
                </div>
                <div class="card-details">
                  <div class="card-details-left">
                    Email Id
                    <span *ngIf="editGeneralInfo" style="color: brown">*</span>
                  </div>
                  <div class="card-details-right" *ngIf="!editGeneralInfo">
                    {{ profileData?.email }}
                    <img
                      src="../../../assets/img/tick-verify.svg"
                      *ngIf="emailVerified > 0"
                    />
                  </div>
                  <div class="card-details-right" *ngIf="editGeneralInfo">
                    <mat-form-field>
                      <input matInput formControlName="email" />
                    </mat-form-field>
                  </div>
                </div>
                <div class="card-details">
                  <div class="card-details-left">Date of Birth</div>
                  <div class="card-details-right" *ngIf="!editGeneralInfo">
                    {{ profileData?.dob | date : "MM/dd/yyyy" }}
                  </div>
                  <div class="card-details-right" *ngIf="editGeneralInfo">
                    <mat-form-field>
                      <input
                        matInput
                        [matDatepicker]="picker"
                        [max]="maxDate"
                        formControlName="dob"
                      />
                      <mat-datepicker-toggle
                        matSuffix
                        [for]="picker"
                      ></mat-datepicker-toggle>
                      <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>
                  </div>
                </div>
                <div class="card-details">
                  <div class="card-details-left">Gender</div>
                  <div class="card-details-right" *ngIf="!editGeneralInfo">
                    {{ profileData?.gender }}
                  </div>
                  <div class="card-details-right" *ngIf="editGeneralInfo">
                    <mat-form-field appearance="fill">
                      <mat-select formControlName="gender" style="width: 100%">
                        <mat-option>Select Gender</mat-option>
                        <mat-option value="male">Male</mat-option>
                        <mat-option value="female">Female</mat-option>
                        <mat-option value="others">Others</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </mat-card-content>
      </div>
    </div>
  </mat-card>
</div>
